import { useSearchParams } from "react-router-dom";
import { useJointBillServicePeriod } from "@pages/BillsPage/useJointBillServicePeriod";
import { useValidJointBillServicesForPeriod } from "@hooks/useValidJointBillServicesForPeriod";
import { useOverviewQuery } from "@services/overview/queries";
import { type IOverviewJointBillService } from "@services/overview/types";
import { isNullOrUndefined } from "@utils/common";

export const useVisibleJointBillServiceIds =
  (): IOverviewJointBillService["jointBillServiceId"][] => {
    const { periodId = 0 } = useJointBillServicePeriod();
    const validJbsForPeriod = useValidJointBillServicesForPeriod(periodId);
    const [searchParams] = useSearchParams();
    const jointBillServiceFilter = searchParams.getAll("jbsId");
    const { data: overview } = useOverviewQuery();

    const filteredJointBillServices = jointBillServiceFilter.length
      ? overview?.jointBillServices.filter((jbs) =>
          jointBillServiceFilter.includes(jbs.jointBillServiceId.toString()),
        )
      : null;

    const jointBillServices = (
      !isNullOrUndefined(filteredJointBillServices)
        ? filteredJointBillServices
        : overview?.jointBillServices
    )
      ?.filter((jbs) => validJbsForPeriod.includes(jbs.jointBillServiceId))
      .sort((a, b) => a.sortOrder - b.sortOrder);

    const jbsIds = jointBillServices?.map((jbs) => jbs.jointBillServiceId);

    return jbsIds ?? [];
  };
